import { dateFormatter, useVideoPageLogic, videoLibraryMessages } from 'azshared';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Card, CardSize } from '../../../components/card/card';
import { AppHeader } from '../../../components/header/header';
import { AppSvgIcon } from '../../../components/svg-icon/app-svg-icon';

import './azimut-for-you.scss';
import { VideoPlayer } from '../../../components/video-player/video-player';
import { EmptyStatePage, EmptyStatePageIcon } from 'src/components/empty-state-page/empty-state-page';
import { useGlobalActions } from 'src/hooks/global-actions';
import { Loader, LoaderSize } from 'src/components/loader/loader';

export const AzimutForYouPage = () => {
  const { formatMessage } = useIntl();
  const globalActions = useGlobalActions();
  const { videos, isLoadingVideos } = useVideoPageLogic(globalActions);

  const isEmpty = useMemo(() => {
    return !videos || (videos.featured.length === 0 && videos.others.length === 0);
  }, [videos]);

  return (
    <div className='azimut-for-you-page'>
      <AppHeader />
      {!isLoadingVideos && isEmpty && (
        <>
          <h2>{formatMessage(videoLibraryMessages.azimutForYouLable)}</h2>
          <EmptyStatePage text={formatMessage(videoLibraryMessages.noVideoLabel)} icon={EmptyStatePageIcon.NoVideos} />
        </>
      )}
      {!isLoadingVideos && !isEmpty && (
        <Card title={formatMessage(videoLibraryMessages.azimutForYouLable)} sizeVariant={CardSize.MAXI}>
          <div className='azimut-for-you-page-card'>
            <div className='foreground-section'>
              <div className='foreground-section-title'>
                <AppSvgIcon icon={'video'} />
                <span>{formatMessage(videoLibraryMessages.inTheForegroundLabel)}</span>
              </div>
              {videos?.featured?.map((video, index) => (
                <div key={`foreground-${index}`} className='video-container'>
                  <VideoPlayer video={video.videoUrl} />
                  {video.uploadDate && <p className='video-upload-date'>{dateFormatter(new Date(video.uploadDate))}</p>}
                  {video.title && <p className='video-title'>{video.title}</p>}
                </div>
              ))}
            </div>
            <div className='other-section'>
              <div className='other-section-title'>{formatMessage(videoLibraryMessages.otherVideoLabel)}</div>
              {videos?.others?.map((video, index) => (
                <div key={`other-${index}`} className='video-container'>
                  <VideoPlayer video={video.videoUrl} />
                  {video.uploadDate && <p className='video-upload-date'>{dateFormatter(new Date(video.uploadDate))}</p>}
                  {video.title && <p className='video-title'>{video.title}</p>}
                </div>
              ))}
            </div>
          </div>
        </Card>
      )}
      {isLoadingVideos && (
        <>
          <h2>{formatMessage(videoLibraryMessages.azimutForYouLable)}</h2>
          <div className='azimut-for-you-page-card azimut-for-you-page-card-loader'>
            <Loader loadersize={LoaderSize.XL} />
          </div>
        </>
      )}
    </div>
  );
};
